(function () {
  if (window.__VIVILAND_CART_MODAL_INITIALIZED__) return;
  window.__VIVILAND_CART_MODAL_INITIALIZED__ = true;

  var config = window.VivilandCartModalConfig || {};
  var nativeFetch = window.fetch.bind(window);
  var qualifierKey = '_viviland_gift_qualifier';
  var giftKey = '_viviland_free_gift';
  var state = {
    addingGift: false,
    purchaseIntent: null,
    giftProduct: null,
    giftProductRequest: null,
    giftVariants: [],
    selectedGift: null,
    giftLoadError: '',
    lastFocus: null,
    previousBodyOverflow: '',
    lastAddedItem: null,
    normalizing: false,
    lastCart: null,
    cartRefreshTimer: null,
    cartOperation: null,
    checkoutValidation: null,
    checkoutStatus: 'pending',
    checkoutMessage: 'Checking your free gift…',
    checkoutBypass: false,
    giftVerificationUncertain: false,
    lastHandledAddKey: '',
    lastHandledAddAt: 0,
    validationToken: 0,
    cartVersion: 0,
    externalMutations: 0
  };

  var overlay = document.getElementById('vivi-cart-modal-overlay');
  var modal = document.getElementById('vivi-cart-modal');
  var closeButton = document.getElementById('vivi-cart-modal-close');
  var modalTitle = document.getElementById('vivi-cart-modal-title');
  var itemImage = document.getElementById('vivi-added-item-image');
  var itemTitle = document.getElementById('vivi-added-item-title');
  var itemVariant = document.getElementById('vivi-added-item-variant');
  var itemPrice = document.getElementById('vivi-added-item-price');
  var giftPanel = document.getElementById('vivi-gift-panel');
  var giftAddedState = document.getElementById('vivi-gift-added-state');
  var giftAddedTitle = document.getElementById('vivi-gift-added-title');
  var giftUnavailable = document.getElementById('vivi-gift-unavailable');
  var giftColors = document.getElementById('vivi-gift-colors');
  var giftFieldset = document.getElementById('vivi-gift-fieldset');
  var giftImage = document.getElementById('vivi-gift-image');
  var giftProductTitle = document.getElementById('vivi-gift-product-title');
  var giftHelp = document.getElementById('vivi-gift-selection-help');
  var giftError = document.getElementById('vivi-gift-error');
  var giftAddButton = document.getElementById('vivi-gift-add');
  var giftChangeButton = document.getElementById('vivi-gift-change');
  var continueButton = document.getElementById('vivi-continue-shopping');
  var viewCartLink = document.getElementById('vivi-view-cart');
  var reopenButtons = document.querySelectorAll('[data-vivi-gift-reopen]');
  var buyNowSummary = document.getElementById('vivi-buy-now-summary');
  var buyNowItems = document.getElementById('vivi-buy-now-items');
  var buyNowTotal = document.getElementById('vivi-buy-now-total');
  var buyNowStatus = document.getElementById('vivi-buy-now-status');
  var buyNowButton = document.getElementById('vivi-buy-now-checkout');
  var retryGiftButton = document.getElementById('vivi-buy-now-retry-gifts');

  if (!overlay || !modal) return;

  function shopRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function route(path) {
    return shopRoot().replace(/\/?$/, '/') + String(path).replace(/^\//, '');
  }

  function normalizeUrl(url) {
    if (!url) return '';
    return String(url).indexOf('//') === 0 ? 'https:' + url : String(url);
  }

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: config.currency || 'USD'
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function itemProperties(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function giftAllocationAmount(item) {
    var allowed = (config.giftVariantIds || []).map(Number);
    if (!item || allowed.indexOf(Number(item.variant_id)) === -1) return 0;
    var allocations = Array.isArray(item.line_level_discount_allocations) ? item.line_level_discount_allocations : [];
    var amount = allocations.reduce(function (sum, allocation) {
      var application = allocation.discount_application || {};
      var supportedType = application.type == null || application.type === '' || application.type === 'automatic';
      var fullGift = supportedType && application.value_type === 'percentage' && Number(application.value) === 100 &&
        application.target_type === 'line_item' && application.target_selection === 'entitled';
      return sum + (fullGift ? Math.max(0, Number(allocation.amount) || 0) : 0);
    }, 0);
    return Math.max(0, Math.min(amount, Number(item.original_line_price) - Number(item.final_line_price)));
  }

  function hasFreeGiftDiscount(item) {
    return !!item && Number(item.original_line_price) > 0 && Number(item.final_line_price) === 0 && giftAllocationAmount(item) === Number(item.original_line_price);
  }

  function isGift(item) {
    var properties = itemProperties(item);
    if (String(properties[giftKey] || '').toLowerCase() === 'yes') return true;
    return false;
  }

  function isQualifier(item) {
    if (!item || isGift(item) || Number(item.original_line_price) <= 0) return false;
    if (typeof item.viviVerifiedQualifier === 'boolean') return item.viviVerifiedQualifier;
    return (config.qualifyingProductIds || []).map(Number).indexOf(Number(item.product_id)) !== -1 ||
      String(itemProperties(item)[qualifierKey] || '').toLowerCase() === 'yes';
  }

  function requestJSON(url, options, failure) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var settings = Object.assign({ credentials: 'same-origin' }, options || {});
    var isWrite = String(settings.method || 'GET').toUpperCase() !== 'GET';
    if (controller) settings.signal = controller.signal;
    var timer;
    var timeout = new Promise(function (_, reject) {
      timer = window.setTimeout(function () {
        if (controller) controller.abort();
        reject(new Error(failure));
      }, 6000);
    });
    var request = nativeFetch(url, settings).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok) {
          var rejected = new Error(body.description || failure);
          rejected.viviWriteRejected = true;
          throw rejected;
        }
        return body;
      });
    });
    return Promise.race([request, timeout]).catch(function (error) {
      if (!isWrite && !error.viviWriteRejected) throw new Error(failure);
      if (error && error.name === 'AbortError') error = new Error(failure);
      if (isWrite && !error.viviWriteRejected) error.viviWriteUncertain = true;
      throw error;
    }).finally(function () { window.clearTimeout(timer); });
  }

  function cartHasGift(cart) {
    return !!(cart && Array.isArray(cart.items) && cart.items.some(isGift));
  }

  function cartHasGiftBenefit(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    var qualifiedQuantity = cart.items.reduce(function (sum, item) {
      return sum + (item.viviVerifiedQualifier === true ? Number(item.quantity) || 0 : 0);
    }, 0);
    if (qualifiedQuantity < 2) return false;
    var saving = cart.items.reduce(function (sum, item) { return sum + giftAllocationAmount(item); }, 0);
    if (saving <= 0) return false;
    var oneGift = cart.items.some(function (item) {
      return giftAllocationAmount(item) > 0 && Number(item.quantity) > 0 &&
        saving === Number(item.original_line_price) / Number(item.quantity);
    });
    var originalTotal = cart.items.reduce(function (sum, item) { return sum + Number(item.original_line_price); }, 0);
    return oneGift && Number.isFinite(Number(cart.total_price)) && Number(cart.total_price) <= originalTotal - saving;
  }

  function cartHasQualifier(cart) {
    return !!(cart && Array.isArray(cart.items) && cart.items.some(isQualifier));
  }

  function wait(milliseconds) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, milliseconds);
    });
  }

  function getCartAttempt() {
    var version = state.cartVersion;
    return requestJSON(config.cartJsonUrl || route('cart.js'), {
      cache: 'no-store', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }, config.verificationMessage || 'We could not verify your bag. Please retry checkout.').then(verifyGiftQualifiers).then(function (cart) {
      if (version !== state.cartVersion) throw new Error(config.changedMessage || 'Your cart changed. Please retry checkout.');
      return cart;
    });
  }

  function verifyGiftQualifiers(cart) {
    if (!cartHasGift(cart) && !(cart && Array.isArray(cart.items) && cart.items.some(function (item) { return giftAllocationAmount(item) > 0; }))) return Promise.resolve(cart);
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer;
    var timeout = new Promise(function (_, reject) {
      timer = window.setTimeout(function () {
        if (controller) controller.abort();
        reject(new Error(config.verificationMessage || 'We could not verify your gift. Please retry checkout.'));
      }, 6000);
    });
    var options = { credentials: 'same-origin', cache: 'no-store' };
    if (controller) options.signal = controller.signal;
    var request = nativeFetch((config.cartUrl || route('cart')) + '?section_id=viviland-cart-gift-data', options).then(function (response) {
      if (!response.ok) throw new Error(config.verificationMessage || 'We could not verify your gift. Please retry checkout.');
      return response.text();
    }).catch(function () {
      throw new Error(config.verificationMessage || 'We could not verify your bag. Please retry checkout.');
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var data = doc.querySelector('[data-vivi-gift-cart-data]');
      var result = data && JSON.parse(data.textContent);
      if (!result || !Array.isArray(result.items) || result.items.length !== cart.items.length) throw new Error(config.verificationMessage || 'We could not verify your gift. Please retry checkout.');
      cart.items.forEach(function (item) {
        var match = result.items.find(function (entry) { return entry.key === item.key && Number(entry.quantity) === Number(item.quantity); });
        if (!match) throw new Error(config.changedMessage || 'Your cart changed. Please retry checkout.');
        item.viviVerifiedQualifier = match.eligible === true;
      });
      return cart;
    });
    return Promise.race([request, timeout]).finally(function () { window.clearTimeout(timer); });
  }

  function getCart(attempt) {
    var retry = typeof attempt === 'number' && Number.isFinite(attempt) ? attempt : 0;
    return getCartAttempt().catch(function (error) {
      if (retry >= 1) throw error;
      return wait(700).then(function () { return getCart(retry + 1); });
    });
  }

  function giftCartValidation(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return { valid: false, message: 'We could not verify your cart. Checkout is paused—please refresh and try again.' };
    }

    var gifts = cart.items.filter(isGift);
    if (!gifts.length) return { valid: true, message: '' };
    if (!cart.items.some(function (line) { return !isGift(line) && line.viviVerifiedQualifier === true && Number(line.original_line_price) > 0; })) {
      return { valid: false, message: 'Your cart no longer qualifies for this gift. Please update the cart before checkout.' };
    }
    if (gifts.length !== 1) {
      return { valid: false, message: 'We found more than one gift. Checkout is paused while the cart is corrected.' };
    }

    var gift = gifts[0];
    var allowedIds = (config.giftVariantIds || []).map(Number);
    if (allowedIds.indexOf(Number(gift.variant_id)) === -1) {
      return { valid: false, message: 'This gift option is not eligible. Please choose an available TWIN gift.' };
    }
    if (Number(gift.quantity) !== 1) {
      return { valid: false, message: 'The free gift quantity must be 1 before checkout.' };
    }
    if (!isActuallyFreeGift(gift, cart)) {
      return { valid: false, message: 'The full gift discount is not confirmed. Checkout is paused to prevent an unexpected charge.' };
    }

    return { valid: true, message: '' };
  }

  function checkoutControls() {
    return document.querySelectorAll('[data-vivi-checkout-control], button[name="checkout"], input[name="checkout"]');
  }

  function checkoutStatusNodes() {
    return document.querySelectorAll('[data-vivi-checkout-status]');
  }

  function applyCheckoutStatus() {
    var locked = state.checkoutStatus !== 'valid';
    document.documentElement.setAttribute('data-vivi-gift-checkout', state.checkoutStatus);

    checkoutControls().forEach(function (control) {
      if (locked) {
        if (!control.hasAttribute('data-vivi-gift-lock')) {
          control.setAttribute('data-vivi-was-disabled', control.disabled ? 'true' : 'false');
        }
        control.setAttribute('data-vivi-gift-lock', 'true');
        control.disabled = true;
        control.setAttribute('aria-disabled', 'true');
      } else if (control.getAttribute('data-vivi-gift-lock') === 'true') {
        var wasDisabled = control.getAttribute('data-vivi-was-disabled') === 'true';
        control.disabled = wasDisabled;
        if (!wasDisabled) control.removeAttribute('aria-disabled');
        control.removeAttribute('data-vivi-gift-lock');
        control.removeAttribute('data-vivi-was-disabled');
      }
    });

    document.querySelectorAll('[data-vivi-accelerated-checkout]').forEach(function (container) {
      container.toggleAttribute('inert', locked);
      container.setAttribute('aria-disabled', locked ? 'true' : 'false');
      container.classList.toggle('vivi-checkout-locked', locked);
    });

    document.querySelectorAll('[data-vivi-checkout-retry]').forEach(function (button) {
      button.hidden = state.checkoutStatus !== 'invalid';
    });

    checkoutStatusNodes().forEach(function (node) {
      if (node.textContent !== state.checkoutMessage) node.textContent = state.checkoutMessage;
      node.hidden = state.checkoutStatus === 'valid';
      node.setAttribute('role', state.checkoutStatus === 'invalid' ? 'alert' : 'status');
    });
  }

  function setCheckoutStatus(status, message) {
    if (status === 'valid' && state.externalMutations > 0) {
      status = 'pending';
      message = config.checkingMessage || 'Checking your free gift…';
    }
    state.checkoutStatus = status;
    state.checkoutMessage = message || '';
    applyCheckoutStatus();
  }

  function syncCheckoutWithCart(cart) {
    if (state.externalMutations > 0) {
      var message = config.checkingMessage || 'Checking your free gift…';
      setCheckoutStatus('pending', message);
      return { valid: false, message: message };
    }
    var result = giftCartValidation(cart);
    setCheckoutStatus(result.valid ? 'valid' : 'invalid', result.message);
    return result;
  }

  function validateCheckoutState(preserveControls) {
    var token = ++state.validationToken;
    setCheckoutStatus('pending', config.checkingMessage || 'Checking your free gift…');
    var pendingOperation = state.cartOperation || Promise.resolve();
    var validation = Promise.resolve(pendingOperation).catch(function () { return null; }).then(getCart).then(function (cart) {
      return normalizeGiftCart(cart, preserveControls);
    }).then(function (cart) {
      if (token !== state.validationToken) return false;
      state.lastCart = cart;
      toggleReopen(cart);
      var valid = syncCheckoutWithCart(cart).valid;
      if (!preserveControls || !valid) updateThemeCart(null, cart);
      return valid;
    }).catch(function (error) {
      if (token === state.validationToken) {
        setCheckoutStatus('invalid', error.message || 'We could not verify your free gift. Checkout is paused—please refresh and try again.');
      }
      return false;
    });
    state.checkoutValidation = validation;
    return validation;
  }

  function requestCheckout(control, mayProceed) {
    return validateCheckoutState(true).then(function (valid) {
      if (!valid) {
        var status = document.querySelector('[data-vivi-checkout-status]:not([hidden])');
        if (status) {
          status.setAttribute('tabindex', '-1');
          status.focus();
        }
        return false;
      }
      if (mayProceed && !mayProceed()) return false;
      state.checkoutBypass = true;
      window.setTimeout(function () { state.checkoutBypass = false; }, 250);
      if (control && typeof control.click === 'function') control.click();
      else window.location.assign(route('checkout'));
      return true;
    });
  }

  window.VivilandGiftCheckoutGate = {
    openBuyNow: openBuyNow,
    validate: validateCheckoutState,
    requestCheckout: requestCheckout,
    isBypassing: function () { return state.checkoutBypass; },
    isReady: function () { return state.checkoutStatus === 'valid'; }
  };

  // A purchase intent belongs to one confirmed add. Closing the dialog cancels
  // navigation, never the already-confirmed cart change.
  function renderBuyNowSummary(cart) {
    var intent = state.purchaseIntent;
    if (!buyNowSummary || !buyNowButton) return;
    modal.classList.toggle('vivi-buy-now', !!intent);
    buyNowSummary.hidden = !intent;
    buyNowButton.hidden = !intent;
    if (retryGiftButton) retryGiftButton.hidden = !intent || intent.stage !== 'choice' || !state.giftLoadError || intent.busy;
    if (!intent) return;
    continueButton.textContent = 'Keep shopping';
    if (cart) {
      buyNowItems.hidden = cart.items.length === 1;
      buyNowItems.replaceChildren();
      cart.items.forEach(function (item) {
        var row = document.createElement('li');
        row.textContent = (item.product_title || item.title || 'Item') +
          (item.variant_title && item.variant_title !== 'Default Title' ? ' · ' + item.variant_title : '') +
          ' × ' + item.quantity + ' — ' + formatMoney(item.final_line_price);
        buyNowItems.appendChild(row);
      });
      buyNowTotal.textContent = 'Subtotal: ' + formatMoney(cart.total_price);
      intent.cartSignature = cartDisplayState(cart);
    }
    buyNowStatus.textContent = intent.message || 'Shipping and applicable taxes are calculated at checkout.';
    buyNowButton.disabled = intent.busy || intent.stage === 'loading';
    buyNowButton.textContent = intent.stage === 'error' ? 'Retry checkout review' :
      intent.stage === 'choice' ? 'Continue without adding a gift' : 'Continue to checkout';
    if (intent.stage === 'loading') buyNowButton.textContent = 'Checking your bag…';
  }

  function prepareBuyNow(intent) {
    if (state.purchaseIntent !== intent || intent.busy) return Promise.resolve();
    intent.stage = 'loading';
    intent.message = 'Checking your items and free gift options…';
    renderBuyNowSummary();
    var pending = state.cartOperation || Promise.resolve();
    return Promise.resolve(pending).catch(function () {}).then(getCart).then(function (cart) {
      return normalizeGiftCart(cart);
    }).then(function (cart) {
      if (state.purchaseIntent !== intent) return null;
      // Do not offer checkout if the just-added product has disappeared.
      if (!cart.items.some(function (line) {
        return !isGift(line) && Number(line.variant_id || line.id) === Number(intent.item.variant_id || intent.item.id);
      })) throw new Error('Your selected item is no longer in the bag. Please review your bag.');
      state.lastCart = cart;
      updateThemeCart(null, cart);
      syncCheckoutWithCart(cart);
      var eligible = !config.giftOffersPaused && !cartHasGift(cart) && !cartHasGiftBenefit(cart) && cartHasQualifier(cart);
      return (eligible ? ensureGiftOptions() : Promise.resolve()).then(function () {
        if (state.purchaseIntent !== intent) return;
        intent.stage = eligible ? 'choice' : 'review';
        intent.message = state.giftLoadError && eligible
          ? 'Gift colors could not be loaded. You can retry, or continue without adding a gift.' : '';
        setModalState(cart, intent.item, false);
        modalTitle.textContent = eligible ? 'Choose your free gift' : 'Ready to checkout';
        if (eligible && !state.giftVariants.length) {
          intent.message = state.giftLoadError ? intent.message : 'No gift colors are available right now. You can continue without adding a gift.';
        }
        renderBuyNowSummary(cart);
      });
    }).catch(function (error) {
      if (state.purchaseIntent !== intent) return;
      intent.stage = 'error';
      intent.message = error.message || 'We could not check your bag. Please retry.';
      giftPanel.hidden = true;
      giftAddedState.hidden = true;
      giftUnavailable.hidden = true;
      renderBuyNowSummary();
    });
  }

  function openBuyNow(item) {
    if (!buyNowButton || !buyNowSummary) return Promise.reject(new Error('Please open your bag to continue checkout.'));
    var intent = { item: item, stage: 'loading', busy: false, cartSignature: '', message: '' };
    state.purchaseIntent = intent;
    // Open immediately, but never show choices from a previous purchase.
    openModal({ items: [], item_count: 0, total_price: 0 }, item, false);
    giftPanel.hidden = true;
    giftAddedState.hidden = true;
    giftUnavailable.hidden = true;
    buyNowItems.replaceChildren();
    buyNowTotal.textContent = '';
    modalTitle.textContent = 'Preparing your checkout';
    renderBuyNowSummary();
    return prepareBuyNow(intent);
  }

  function continueBuyNow(intent, giftCart) {
    if (state.purchaseIntent !== intent) return Promise.resolve(false);
    var signature = giftCart ? cartDisplayState(giftCart) : intent.cartSignature;
    intent.busy = true;
    intent.message = 'Checking your bag before checkout…';
    renderBuyNowSummary();
    return requestCheckout(null, function () {
      if (state.purchaseIntent !== intent || overlay.hidden) return false;
      // A later tab, quantity change or normalization must not silently alter
      // the order the customer just reviewed.
      return !!state.lastCart && signature === cartDisplayState(state.lastCart);
    }).then(function (navigated) {
      if (!navigated && state.purchaseIntent === intent) {
        intent.stage = 'error';
        intent.message = 'Your bag changed or could not be verified. Retry to review it before checkout.';
      }
      return navigated;
    }).finally(function () {
      if (state.purchaseIntent === intent) {
        intent.busy = false;
        renderBuyNowSummary();
      }
    });
  }

  function buyNowWithGift() {
    var intent = state.purchaseIntent;
    if (!intent) return addSelectedGift();
    if (intent.busy || intent.stage !== 'choice' || !state.selectedGift) return;
    var selectedId = Number(state.selectedGift.id);
    intent.busy = true;
    renderBuyNowSummary();
    return Promise.resolve(addSelectedGift()).then(function (cart) {
      if (state.purchaseIntent !== intent) return;
      var selectedGift = cart && cart.items.find(function (line) {
        return isGift(line) && Number(line.variant_id) === selectedId;
      });
      if (cart && !state.giftVerificationUncertain &&
          (isActuallyFreeGift(selectedGift, cart) || (!cartHasGift(cart) && cartHasGiftBenefit(cart)))) {
        return continueBuyNow(intent, cart);
      }
      intent.stage = 'error';
      intent.message = 'The gift could not be confirmed. Review your bag before continuing.';
    }).finally(function () {
      if (state.purchaseIntent === intent) {
        intent.busy = false;
        renderBuyNowSummary();
      }
    });
  }

  function loadGiftProduct() {
    if (state.giftProduct) return Promise.resolve(state.giftProduct);
    if (state.giftProductRequest) return state.giftProductRequest;
    state.giftProductRequest = requestJSON(route('products/' + config.giftProductHandle + '.js'), {}, 'Gift product could not be loaded.').then(function (product) {
      state.giftLoadError = '';
      state.giftProduct = product;
      state.giftVariants = getAllowedGiftVariants(product);
      return product;
    }).finally(function () { state.giftProductRequest = null; });
    return state.giftProductRequest;
  }

  function ensureGiftOptions() {
    return loadGiftProduct().catch(function () {
      state.giftLoadError = 'Your item is in the cart, but the free gift colors could not be loaded right now. You can keep shopping and try again from the gift reminder.';
      state.giftVariants = [];
      return null;
    });
  }

  function getOptionNames(product) {
    return (product.options || []).map(function (option) {
      return typeof option === 'string' ? option : (option && option.name) || '';
    });
  }

  function getAllowedGiftVariants(product) {
    var allowed = (config.giftVariantIds || []).map(Number);
    var names = getOptionNames(product);
    var colorIndex = names.findIndex(function (name) { return /color|colour|颜色/i.test(name); });
    var sizeIndex = names.findIndex(function (name) { return /size|bedding|尺寸|尺码/i.test(name); });

    return (product.variants || []).filter(function (variant) {
      if (!variant.available || allowed.indexOf(Number(variant.id)) === -1) return false;
      var options = Array.isArray(variant.options)
        ? variant.options
        : [variant.option1, variant.option2, variant.option3];
      return sizeIndex === -1 || String(options[sizeIndex] || '').toUpperCase() === String(config.giftSize).toUpperCase();
    }).map(function (variant) {
      var options = Array.isArray(variant.options)
        ? variant.options
        : [variant.option1, variant.option2, variant.option3];
      var featured = variant.featured_image || {};
      return {
        id: Number(variant.id),
        color: colorIndex === -1 ? variant.title : String(options[colorIndex] || variant.title),
        price: Number(variant.price || 0),
        image: normalizeUrl(featured.src || featured.url || '')
      };
    });
  }

  function swatchColor(name) {
    var colors = {
      'navy': '#292e57',
      'sage green': '#97a482',
      'rose red': '#c47795',
      'white': '#ffffff'
    };
    return colors[String(name || '').toLowerCase()] || '#e6e6e6';
  }

  function showError(message) {
    var displayMessage = String(message || 'Unable to update your gift. Please try again.');
    if (/unexpected token|<!doctype|not valid json|failed to fetch|networkerror|load failed/i.test(displayMessage)) {
      displayMessage = 'Unable to update your gift. Please try again.' + (/Your previous free gift was kept\./.test(displayMessage) ? ' Your previous free gift was kept.' : '');
    }
    giftError.textContent = displayMessage;
    giftError.hidden = false;
  }

  function clearError() {
    giftError.textContent = '';
    giftError.hidden = true;
  }

  function renderAddedItem(item) {
    if (!item) {
      document.getElementById('vivi-added-item').hidden = true;
      return;
    }
    document.getElementById('vivi-added-item').hidden = false;
    var image = item.featured_image && (item.featured_image.url || item.featured_image.src)
      ? item.featured_image.url || item.featured_image.src
      : item.image;
    itemImage.src = normalizeUrl(image || '');
    itemImage.alt = item.product_title || item.title || 'Added product';
    itemTitle.textContent = item.product_title || item.title || 'Item added';
    var variantText = item.variant_title && item.variant_title !== 'Default Title'
      ? item.variant_title.split(' / ').join(' · ')
      : '';
    var quantity = Number(item.quantity || 1);
    itemVariant.textContent = (variantText ? variantText + ' · ' : '') + 'Qty: ' + quantity;
    itemPrice.textContent = formatMoney(item.final_price != null ? item.final_price : item.price) + (quantity > 1 ? ' each' : '');
  }

  function renderGiftOptions() {
    state.selectedGift = null;
    giftColors.innerHTML = '';
    giftAddButton.disabled = true;
    giftAddButton.textContent = 'Choose a color';
    giftHelp.textContent = 'Pick your favorite color.';
    clearError();

    var product = state.giftProduct;
    var fallbackImage = product && product.featured_image
      ? (typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src)
      : (product && product.images && product.images[0]);
    giftProductTitle.textContent = 'Twin sheet set';
    giftProductTitle.title = product ? product.title : 'Twin sheet set';
    giftImage.src = normalizeUrl(fallbackImage || '');

    state.giftVariants.forEach(function (variant) {
      var button = document.createElement('button');
      var swatch = document.createElement('span');
      var label = document.createElement('span');
      button.type = 'button';
      button.className = 'vivi-gift-color';
      button.setAttribute('aria-pressed', 'false');
      button.dataset.variantId = String(variant.id);
      swatch.className = 'vivi-gift-color__swatch';
      swatch.style.setProperty('--vivi-swatch', swatchColor(variant.color));
      swatch.setAttribute('aria-hidden', 'true');
      label.textContent = variant.color;
      button.appendChild(swatch);
      button.appendChild(label);
      button.addEventListener('click', function () {
        if (state.addingGift || (state.purchaseIntent && state.purchaseIntent.busy)) return;
        state.selectedGift = variant;
        giftColors.querySelectorAll('.vivi-gift-color').forEach(function (element) {
          element.setAttribute('aria-pressed', element === button ? 'true' : 'false');
        });
        if (variant.image) giftImage.src = variant.image;
        giftAddButton.disabled = false;
        giftAddButton.textContent = state.purchaseIntent ? 'Add gift & checkout' : 'Add free gift';
        giftHelp.textContent = variant.color + ' · TWIN selected';
        clearError();
      });
      giftColors.appendChild(button);
    });
  }

  function setModalState(cart, item, forceGiftChoice) {
    var ownedGift = cartHasGift(cart);
    var benefitIncluded = !ownedGift && cartHasGiftBenefit(cart);
    var hasGift = ownedGift || benefitIncluded;
    var eligible = !config.giftOffersPaused && (forceGiftChoice || isQualifier(item) || cartHasQualifier(cart));
    modalTitle.textContent = benefitIncluded ? (config.giftIncludedTitle || 'Free gift already included') : (hasGift && forceGiftChoice ? 'Free gift added' : 'Added to your bag');
    if (giftAddedTitle) giftAddedTitle.textContent = benefitIncluded ? (config.giftIncludedTitle || 'Free gift already included') : 'FREE Gift Added';
    if (giftChangeButton) giftChangeButton.hidden = benefitIncluded;
    renderAddedItem(item || state.lastAddedItem);
    giftPanel.hidden = true;
    giftAddedState.hidden = true;
    giftUnavailable.hidden = true;
    continueButton.classList.remove('vivi-cart-modal__button--primary');
    continueButton.classList.add('vivi-cart-modal__button--secondary');

    if (config.giftOffersPaused) {
      modalTitle.textContent = 'Added to your bag';
      giftUnavailable.textContent = config.offersRestoringMessage;
      giftUnavailable.hidden = false;
      continueButton.classList.remove('vivi-cart-modal__button--secondary');
      continueButton.classList.add('vivi-cart-modal__button--primary');
    } else if (hasGift) {
      var chosenGift = cart.items.find(isGift);
      var giftSummary = document.getElementById('vivi-gift-added-selection');
      if (giftSummary) giftSummary.textContent = benefitIncluded
        ? (config.giftIncludedNotice || 'A free Twin item is already included in your bag. One gift per order.')
        : (chosenGift && chosenGift.variant_title ? chosenGift.variant_title.split(' / ').join(' · ') + ' · Qty: 1' : 'Your free TWIN sheet set is in the bag.');
      giftAddedState.hidden = false;
      continueButton.classList.remove('vivi-cart-modal__button--secondary');
      continueButton.classList.add('vivi-cart-modal__button--primary');
    } else if (eligible && state.giftVariants.length) {
      giftPanel.hidden = false;
      renderGiftOptions();
    } else if (eligible) {
      giftUnavailable.textContent = state.giftLoadError || 'Your order qualifies, but all free TWIN colors are temporarily unavailable. Your purchased item is safely in the cart.';
      giftUnavailable.hidden = false;
      continueButton.classList.remove('vivi-cart-modal__button--secondary');
      continueButton.classList.add('vivi-cart-modal__button--primary');
    } else {
      continueButton.classList.remove('vivi-cart-modal__button--secondary');
      continueButton.classList.add('vivi-cart-modal__button--primary');
    }
  }

  function focusableElements() {
    return Array.prototype.slice.call(modal.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) { return !element.hidden && element.offsetParent !== null; });
  }

  function openModal(cart, item, forceGiftChoice) {
    state.lastFocus = document.activeElement;
    try {
      if (window.Alpine && Alpine.store('xMiniCart') && Alpine.store('xMiniCart').open) {
        Alpine.store('xMiniCart').hideCart();
      }
    } catch (error) {}
    setModalState(cart, item, forceGiftChoice);
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('vivi-cart-modal-open');
    state.previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      modal.focus();
    });
  }

  function closeModal() {
    state.purchaseIntent = null;
    renderBuyNowSummary();
    continueButton.textContent = 'Continue shopping';
    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('vivi-cart-modal-open');
    document.body.style.overflow = state.previousBodyOverflow;
    if (state.lastFocus && typeof state.lastFocus.focus === 'function') state.lastFocus.focus();
  }

  function toggleReopen(cart) {
    var shouldShow = !config.giftOffersPaused && !state.giftVerificationUncertain && cartHasQualifier(cart) && !cartHasGift(cart) && !cartHasGiftBenefit(cart);
    reopenButtons = document.querySelectorAll('[data-vivi-gift-reopen]');
    reopenButtons.forEach(function (button) { button.hidden = !shouldShow; });
    document.querySelectorAll('[data-vivi-gift-reminder]').forEach(function (reminder) {
      reminder.hidden = !shouldShow;
    });
  }

  function updateThemeCart(response, cart) {
    try {
      if (window.Alpine && Alpine.store('xCartHelper')) {
        if (response && response.sections) Alpine.store('xCartHelper').reRenderSections(response.sections);
        Alpine.store('xCartHelper').currentItemCount = Number(cart.item_count || 0);
      }
    } catch (error) {}

    document.querySelectorAll('#cart-icon-bubble span, [data-cart-count], .cart-count').forEach(function (element) {
      if (!element.children.length) element.textContent = String(cart.item_count || 0);
    });
    document.dispatchEvent(new CustomEvent('viviland:cart:updated', { detail: { cart: cart } }));
  }

  function getSections() {
    try {
      if (window.Alpine && Alpine.store('xCartHelper')) {
        return Alpine.store('xCartHelper').getSectionsToRender().map(function (section) { return section.id; });
      }
    } catch (error) {}
    return [];
  }

  function isActuallyFreeGift(item, cart) {
    if (!item || !cart || !Array.isArray(cart.items) || !isGift(item) ||
        Number(item.quantity) !== 1 || Number(item.original_line_price) <= 0 ||
        cart.items.filter(isGift).length !== 1) return false;
    var allowed = (config.giftVariantIds || []).map(Number);
    if (allowed.indexOf(Number(item.variant_id)) === -1) return false;
    var purchases = cart.items.filter(function (line) { return !isGift(line); });
    if (!purchases.some(function (line) { return line.viviVerifiedQualifier === true && Number(line.original_line_price) > 0; })) return false;
    var saving = cart.items.reduce(function (sum, line) { return sum + giftAllocationAmount(line); }, 0);
    var purchaseValue = purchases.reduce(function (sum, line) { return sum + Number(line.original_line_price); }, 0);
    return saving === Number(item.original_line_price) && Number.isFinite(Number(cart.total_price)) && Number(cart.total_price) <= purchaseValue;
  }

  function removeGiftItems(items) {
    var updates = {};
    (items || []).forEach(function (item) { updates[item.key] = 0; });
    if (!Object.keys(updates).length) return Promise.resolve(null);
    return requestJSON(config.cartUpdateUrl || route('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    }, 'Unable to update the existing free gift.');
  }

  function postGiftVariant(variantId, sections) {
    var payload = {
      items: [{
        id: Number(variantId),
        quantity: 1,
        properties: {
          _viviland_free_gift: 'yes',
          _viviland_gift_size: config.giftSize
        }
      }]
    };
    if (sections && sections.length) {
      payload.sections = sections;
      payload.sections_url = window.location.pathname;
    }
    return requestJSON(config.cartAddUrl || route('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    }, 'Unable to add your free gift.');
  }

  function rollbackGiftAttempt(previousGift, selectedId) {
    return getCart().then(function (cart) {
      var attemptedItems = cart.items.filter(function (item) {
        return isGift(item) && Number(item.variant_id) === Number(selectedId);
      });
      return removeGiftItems(attemptedItems).then(getCart);
    }).then(function (cart) {
      if (!previousGift) return cart;
      var previousStillExists = cart.items.some(function (item) {
        return isGift(item) && Number(item.variant_id) === Number(previousGift.variant_id);
      });
      if (previousStillExists) return cart;
      return postGiftVariant(previousGift.variant_id, []).catch(function () { return null; }).then(getCart);
    }).then(function (cart) {
      var chargedGiftItems = cart.items.filter(function (item) { return isGift(item) && !isActuallyFreeGift(item, cart); });
      if (!chargedGiftItems.length) return cart;
      return removeGiftItems(chargedGiftItems).then(getCart);
    });
  }

  function addSelectedGift() {
    if (config.giftOffersPaused) { showError(config.offersRestoringMessage); return; }
    if (state.giftVerificationUncertain) {
      window.location.assign(viewCartLink ? viewCartLink.href : (config.cartUrl || route('cart')));
      return;
    }
    if (state.addingGift || !state.selectedGift) return;
    state.addingGift = true;
    setCheckoutStatus('pending', 'Adding and verifying your free gift…');
    clearError();
    giftAddButton.disabled = true;
    giftAddButton.textContent = 'Adding Your Gift...';

    var selected = state.selectedGift;
    var sections = getSections();
    var previousGift = null;
    var changedExistingGift = false;
    var addResponse = null;
    var beforeTotal = null;

    function acceptGiftCart(cart) {
      updateThemeCart(addResponse, cart);
      state.giftVerificationUncertain = false;
      toggleReopen(cart);
      clearError();
      setModalState(cart, state.lastAddedItem, true);
      syncCheckoutWithCart(cart);
      return cart;
    }

    var operation = getCart().then(function (cart) {
      if (!cartHasQualifier(cart)) throw new Error('Your cart no longer qualifies for this gift.');
      var giftItems = cart.items.filter(isGift);
      beforeTotal = Number(cart.total_price);
      if (!Number.isFinite(beforeTotal)) throw new Error(config.verificationMessage || 'We could not verify your gift. Please retry checkout.');
      if (!giftItems.length && cartHasGiftBenefit(cart)) return { cart: cart, benefitIncluded: true, unchanged: true };
      var selectedAlreadyFree = giftItems.find(function (item) {
        return Number(item.variant_id) === Number(selected.id) && isActuallyFreeGift(item, cart);
      });
      if (selectedAlreadyFree && giftItems.length === 1) return { cart: cart, unchanged: true };

      previousGift = giftItems.find(function (item) { return isActuallyFreeGift(item, cart); }) || giftItems[0] || null;
      changedExistingGift = giftItems.length > 0;
      return removeGiftItems(giftItems).then(function () {
        return postGiftVariant(selected.id, sections);
      }).then(function (response) {
        addResponse = response;
        return getCart();
      }).then(function (updatedCart) { return { cart: updatedCart, unchanged: false }; });
    }).then(function (result) {
      if (result.benefitIncluded) return acceptGiftCart(result.cart);
      var giftItem = result.cart.items.find(function (item) {
        return isGift(item) && Number(item.variant_id) === Number(selected.id);
      });
      if (!isActuallyFreeGift(giftItem, result.cart)) {
        throw new Error('The full gift discount was not applied to your bag, so the gift was removed to prevent an extra charge.');
      }

      if (!result.unchanged && Number(result.cart.total_price) > beforeTotal) {
        throw new Error(config.giftPriceChanged || 'Your offers could not be combined without increasing your total. The new gift was removed; please review your bag.');
      }
      return acceptGiftCart(result.cart);
    }).catch(function (error) {
      var message = error.message || 'Unable to add your free gift. Please try again.';
      if (error.viviWriteUncertain) {
        state.giftVerificationUncertain = true;
        return getCart().then(function (cart) {
          var confirmedGift = cart.items.find(function (item) { return isGift(item) && Number(item.variant_id) === Number(selected.id); });
          if (confirmedGift && isActuallyFreeGift(confirmedGift, cart) && Number(cart.total_price) <= beforeTotal) return acceptGiftCart(cart);
          setCheckoutStatus('invalid', config.giftWriteUncertain || 'We could not confirm the gift update. Please review your bag before trying again.');
          showError(config.giftWriteUncertain || 'We could not confirm the gift update. Please review your bag before trying again.');
          giftAddButton.disabled = false;
          giftAddButton.textContent = viewCartLink ? viewCartLink.textContent : 'View bag';
          return cart;
        });
      }
      var rollback = changedExistingGift || addResponse
        ? rollbackGiftAttempt(previousGift, selected.id)
        : getCart().catch(function () { return null; });
      return rollback.then(function (cart) {
        if (cart) {
          state.giftVerificationUncertain = false;
          updateThemeCart(null, cart);
          toggleReopen(cart);
          syncCheckoutWithCart(cart);
        } else {
          setCheckoutStatus('invalid', 'We could not verify that the gift was removed. Checkout is paused—please refresh and try again.');
        }
        showError(message + (previousGift && cart && cartHasGift(cart) ? ' Your previous free gift was kept.' : ''));
        giftAddButton.disabled = false;
        giftAddButton.textContent = 'Try Again';
        return cart;
      });
    }).catch(function (error) {
      state.giftVerificationUncertain = state.giftVerificationUncertain || !!addResponse;
      setCheckoutStatus('invalid', 'We could not safely restore your cart. Checkout is paused—please refresh and try again.');
      showError(error.message || 'Unable to restore your cart safely.');
      giftAddButton.disabled = false;
      giftAddButton.textContent = state.giftVerificationUncertain && viewCartLink
        ? viewCartLink.textContent
        : 'Try Again';
      return null;
    }).finally(function () {
      state.addingGift = false;
      if (state.cartOperation === operation) state.cartOperation = null;
    });
    state.cartOperation = operation;
    return operation;
  }

  function findAddedItem(previousCart, nextCart) {
    if (!previousCart || !Array.isArray(previousCart.items) || !nextCart || !Array.isArray(nextCart.items)) return null;
    var previousQuantities = {};
    previousCart.items.forEach(function (item) {
      previousQuantities[item.key] = Number(item.quantity || 0);
    });
    var added = null;
    nextCart.items.forEach(function (item) {
      if (isGift(item)) return;
      var delta = Number(item.quantity || 0) - Number(previousQuantities[item.key] || 0);
      if (delta > 0) {
        added = Object.assign({}, item, { quantity: delta });
      }
    });
    return added;
  }

  function parseAddedItems(body) {
    if (!body) return [];
    if (Array.isArray(body.items)) return body.items;
    if (body.product_id || body.variant_id || body.id) return [body];
    return [];
  }

  function addedItemKey(item) {
    return String((item && (item.key || item.variant_id || item.id)) || '');
  }

  function optimisticCartWithItem(cart, item) {
    var optimistic = Object.assign({}, cart || {});
    var items = cart && Array.isArray(cart.items) ? cart.items.slice() : [];
    var key = addedItemKey(item);
    var index = items.findIndex(function (existing) {
      return addedItemKey(existing) === key;
    });
    if (index === -1) items.push(item);
    else items[index] = Object.assign({}, items[index], item);
    optimistic.items = items;
    optimistic.item_count = items.reduce(function (total, entry) {
      return total + Number(entry.quantity || 0);
    }, 0);
    return optimistic;
  }

  function handleSuccessfulAdd(body) {
    var items = parseAddedItems(body).filter(function (item) { return !isGift(item); });
    if (!items.length) return;

    var item = items[items.length - 1];
    var key = addedItemKey(item);
    var now = Date.now();
    if (key && key === state.lastHandledAddKey && now - state.lastHandledAddAt < 1500) return;

    state.lastHandledAddKey = key;
    state.lastHandledAddAt = now;
    state.lastAddedItem = item;
    state.lastCart = optimisticCartWithItem(state.lastCart, item);
    setCheckoutStatus('pending', config.checkingMessage || 'Checking your free gift…');

    getCart().then(function (cart) {
      state.lastCart = cart;
      toggleReopen(cart);
      syncCheckoutWithCart(cart);
      if (!cartHasGift(cart) && !cartHasGiftBenefit(cart) && cartHasQualifier(cart)) {
        return ensureGiftOptions().then(function () { return cart; });
      }
      return cart;
    }).then(function (cart) {
      if (state.purchaseIntent) return;
      openModal(cart, item, false);
    }).catch(function (error) {
      console.error('[Viviland Cart Modal]', error);
    });
  }

  function handleThemeCartChange() {
    setCheckoutStatus('pending', config.checkingMessage || 'Checking your free gift…');
    window.clearTimeout(state.cartRefreshTimer);
    state.cartRefreshTimer = window.setTimeout(function () {
      // Generic cart-change signals are also fired for removals, quantity
      // changes, discount recalculation, gift normalization, and cart clears.
      // Only a confirmed /cart/add response may open the success modal.
      refreshCartState(false);
    }, 100);
  }

  function cartDisplayState(cart) {
    return JSON.stringify({
      total: Number(cart.total_price),
      items: cart.items.map(function (item) {
        return [item.key, Number(item.quantity), Number(item.final_line_price)];
      }).sort(function (left, right) { return String(left[0]).localeCompare(String(right[0])); })
    });
  }

  function normalizeGiftCart(cart, preserveControls) {
    if (state.normalizing || !cart || !Array.isArray(cart.items)) return Promise.resolve(cart);
    var gifts = cart.items.filter(isGift);
    var updates = {};

    var allowedGiftIds = (config.giftVariantIds || []).map(Number);
    var validGift = gifts.find(function (item) {
      return allowedGiftIds.indexOf(Number(item.variant_id)) !== -1 && isActuallyFreeGift(item, cart);
    });

    if (!validGift) {
      gifts.forEach(function (item) { updates[item.key] = 0; });
    } else {
      gifts.forEach(function (item) {
        if (item.key !== validGift.key) updates[item.key] = 0;
        else if (Number(item.quantity) !== 1) updates[item.key] = 1;
      });
    }
    if (!Object.keys(updates).length) return Promise.resolve(cart);

    var previousDisplayState = cartDisplayState(cart);
    var sections = getSections();
    var payload = { updates: updates };
    if (sections.length) {
      payload.sections = sections;
      payload.sections_url = window.location.pathname;
    }

    state.normalizing = true;
    return requestJSON(config.cartUpdateUrl || route('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }, 'Unable to normalize gift quantity.').then(verifyGiftQualifiers).then(function (normalizedCart) {
      if (cartDisplayState(normalizedCart) !== previousDisplayState) {
        document.dispatchEvent(new CustomEvent('viviland:cart:normalized', { detail: { cart: normalizedCart } }));
      }
      if (preserveControls) return normalizedCart;
      if (/\/cart\/?$/.test(window.location.pathname)) {
        window.setTimeout(function () {
          var cartUrl = config.cartUrl || route('cart');
          window.location.replace(cartUrl + '?vivi_gift_synced=' + Date.now());
        }, 300);
      } else {
        updateThemeCart(normalizedCart, normalizedCart);
      }
      return normalizedCart;
    }).finally(function () {
      state.normalizing = false;
    });
  }

  function refreshCartState(allowModal) {
    setCheckoutStatus('pending', config.checkingMessage || 'Checking your free gift…');
    var operation = getCart().then(function (cart) {
      var addedItem = allowModal ? findAddedItem(state.lastCart, cart) : null;
      state.lastCart = cart;
      return normalizeGiftCart(cart).then(function (normalizedCart) {
        state.lastCart = normalizedCart;
        return { cart: normalizedCart, addedItem: addedItem };
      });
    }).then(function (result) {
      var cart = result.cart;
      toggleReopen(cart);
      updateThemeCart(null, cart);
      syncCheckoutWithCart(cart);
      if (
        result.addedItem &&
        addedItemKey(result.addedItem) === state.lastHandledAddKey &&
        Date.now() - state.lastHandledAddAt < 15000
      ) {
        result.addedItem = null;
      }
      if (result.addedItem) {
        state.lastAddedItem = result.addedItem;
        return ensureGiftOptions().then(function () {
          openModal(cart, result.addedItem, false);
        });
      }
    }).catch(function (error) {
      setCheckoutStatus('invalid', error.message || 'We could not verify your free gift. Checkout is paused—please refresh and try again.');
      console.error('[Viviland Gift Cart]', error);
    }).finally(function () {
      if (state.cartOperation === operation) state.cartOperation = null;
    });
    state.cartOperation = operation;
    return operation;
  }

  var observedFetch = window.fetch;
  window.fetch = function () {
    var input = arguments[0];
    var init = arguments[1] || {};
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = String(init.method || (input && input.method) || 'GET').toUpperCase();
    var isBuyNow = !!(init.headers && (typeof init.headers.get === 'function' ? init.headers.get('X-Viviland-Buy-Now') : init.headers['X-Viviland-Buy-Now']));
    var isCartMutation = method !== 'GET' && /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(String(url));
    var isCartAdd = method !== 'GET' && /\/cart\/add(\.js)?(?:\?|$)/.test(String(url));
    if (isCartMutation && !state.checkoutBypass) {
      state.cartVersion += 1;
      state.validationToken += 1;
      state.externalMutations += 1;
      setCheckoutStatus('pending', config.checkingMessage || 'Checking your free gift…');
    }
    var response = observedFetch.apply(window, arguments);
    if (isCartMutation && !state.checkoutBypass) {
      response.then(function (cartResponse) {
        state.externalMutations = Math.max(0, state.externalMutations - 1);
        if (isCartAdd && cartResponse.ok && !isBuyNow) {
          cartResponse.clone().json().then(handleSuccessfulAdd).catch(function () {});
        }
        if (!isBuyNow) handleThemeCartChange();
      }, function () {
        state.externalMutations = Math.max(0, state.externalMutations - 1);
        handleThemeCartChange();
      });
    }
    return response;
  };

  try {
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__viviCartMethod = String(method || 'GET').toUpperCase();
      this.__viviCartUrl = String(url || '');
      return originalOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      xhr.addEventListener('load', function () {
        if (xhr.status < 200 || xhr.status >= 400 || xhr.__viviCartMethod === 'GET') return;
        if (/\/cart\/add(\.js)?(?:\?|$)/.test(xhr.__viviCartUrl)) {
          try { handleSuccessfulAdd(JSON.parse(xhr.responseText)); } catch (error) {}
        }
        if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(xhr.__viviCartUrl)) {
          handleThemeCartChange();
        }
      });
      return originalSend.apply(this, arguments);
    };
  } catch (error) {}

  document.addEventListener('eurus:cart:items-changed', handleThemeCartChange);

  document.addEventListener('click', function (event) {
    if (!config.isCartPage || !event.target.closest) return;
    var cartControl = event.target.closest(
      'button[aria-label^="Remove "], button[aria-label^="Decrease quantity for "], button[aria-label^="Increase quantity for "]'
    );
    if (!cartControl) return;
    window.setTimeout(handleThemeCartChange, 1800);
  }, true);

  document.addEventListener('change', function (event) {
    if (!config.isCartPage || !event.target.matches) return;
    if (event.target.matches('input[aria-label^="Quantity for "]')) {
      window.setTimeout(handleThemeCartChange, 1800);
    }
  }, true);

  var cartForm = config.isCartPage ? document.getElementById('cart') : null;
  if (cartForm) {
    new MutationObserver(function (mutations) {
      var cartRowsChanged = mutations.some(function (mutation) {
        return mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length);
      });
      if (cartRowsChanged) window.setTimeout(handleThemeCartChange, 1800);
    }).observe(cartForm, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (event) {
    if (state.checkoutBypass) return;
    var target = event.target && event.target.closest
      ? event.target.closest('[data-vivi-checkout-control], [data-vivi-accelerated-checkout]')
      : null;
    if (!target) return;
    if (target.matches('[data-vivi-accelerated-checkout]') && state.checkoutStatus === 'valid' && !state.cartOperation) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (target.matches('[data-vivi-accelerated-checkout]')) validateCheckoutState(true);
    else requestCheckout(target);
  }, true);

  document.addEventListener('submit', function (event) {
    if (state.checkoutBypass) return;
    var submitter = event.submitter;
    var isCheckout = submitter && submitter.matches('[data-vivi-checkout-control], [name="checkout"]');
    if (!isCheckout) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    requestCheckout(submitter);
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('[data-vivi-checkout-retry]')) validateCheckoutState(true);
  });
  window.addEventListener('pageshow', function (event) { if (event.persisted) validateCheckoutState(true); });

  new MutationObserver(applyCheckoutStatus).observe(document.body, { childList: true, subtree: true });

  closeButton.addEventListener('click', closeModal);
  continueButton.addEventListener('click', closeModal);
  giftAddButton.addEventListener('click', buyNowWithGift);
  if (retryGiftButton) retryGiftButton.addEventListener('click', function () {
    var intent = state.purchaseIntent;
    if (intent && !intent.busy && intent.stage === 'choice') prepareBuyNow(intent);
  });
  if (buyNowButton) buyNowButton.addEventListener('click', function () {
    var intent = state.purchaseIntent;
    if (!intent || intent.busy || intent.stage === 'loading') return;
    if (intent.stage === 'error') prepareBuyNow(intent);
    else continueBuyNow(intent);
  });
  if (giftChangeButton) {
    giftChangeButton.addEventListener('click', function () {
      if (state.addingGift || giftChangeButton.disabled || (state.purchaseIntent && state.purchaseIntent.busy)) return;
      giftChangeButton.disabled = true;
      giftChangeButton.setAttribute('aria-busy', 'true');
      clearError();
      ensureGiftOptions().then(function () {
        if (overlay.hidden || state.addingGift || (state.purchaseIntent && state.purchaseIntent.busy)) return;
        if (state.purchaseIntent) state.purchaseIntent.stage = 'choice';
        if (state.giftVariants.length) {
          modalTitle.textContent = 'Choose another color';
          giftAddedState.hidden = true;
          giftUnavailable.hidden = true;
          giftPanel.hidden = false;
          renderGiftOptions();
        } else {
          giftPanel.hidden = true;
          giftUnavailable.textContent = state.giftLoadError || 'No other free TWIN colors are available right now. Your current free gift remains in the cart.';
          giftUnavailable.hidden = false;
        }
      }).finally(function () {
        giftChangeButton.disabled = false;
        giftChangeButton.removeAttribute('aria-busy');
      });
    });
  }
  overlay.addEventListener('click', function (event) {
    if (event.target === overlay) closeModal();
  });
  document.addEventListener('keydown', function (event) {
    if (overlay.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }
    if (event.key === 'Tab') {
      var elements = focusableElements();
      if (!elements.length) return;
      var first = elements[0];
      var last = elements[elements.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-vivi-gift-reopen]');
    if (!trigger) return;
    event.preventDefault();
    Promise.all([ensureGiftOptions(), getCart()]).then(function (values) {
      openModal(values[1], state.lastAddedItem, true);
    }).catch(function (error) {
      console.error('[Viviland Gift Reopen]', error);
    });
  });

  setCheckoutStatus('pending', config.checkingMessage || 'Checking your free gift…');
  var initialOperation = getCart().then(function (cart) {
    if (cartHasQualifier(cart) && !cartHasGift(cart) && !cartHasGiftBenefit(cart)) ensureGiftOptions();
    state.lastCart = cart;
    toggleReopen(cart);
    return normalizeGiftCart(cart);
  }).then(function (cart) {
    state.lastCart = cart;
    toggleReopen(cart);
    syncCheckoutWithCart(cart);
    return cart;
  }).catch(function (error) {
    setCheckoutStatus('invalid', error.message || 'We could not verify your free gift. Checkout is paused—please refresh and try again.');
    console.error('[Viviland Cart Modal Init]', error);
  }).finally(function () {
    if (state.cartOperation === initialOperation) state.cartOperation = null;
  });
  state.cartOperation = initialOperation;
})();

